<div class="management-page">
    <ng-container *ngIf="showMigration && !isLoading">
        <app-comming-soon [path]='"management"'></app-comming-soon>
    </ng-container>
    <ng-container *ngIf="!showMigration && !isLoading && showNoTopics">
        <div class="no-task-wrapper">
            <div class="no-topics-container">
                <div class="icon">
                    <img src="../../../assets/images/no-tasks-icon.svg" alt="">
                </div>
                <div class="text-area">
                    <div class="main">No ongoing topics</div>
                    <div class="sub-text">Looks like there are no ongoing topics for now. Please check again later</div>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="!showMigration && !isLoading && taskLoadError">
        <div class="no-task-wrapper">
            <div class="no-topics-container task-load-error">
                <div class="icon"><mat-icon>link_off</mat-icon></div>
                <div class="text-area">
                    <div class="main">{{taskLoadError.title}}</div>
                    <div class="sub-text">{{taskLoadError.description}}</div>
                </div>
                <button type="button" class="retry-task-load" mat-flat-button (click)="retryLoadTasks()">
                    <mat-icon>refresh</mat-icon>
                    Try again
                </button>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="!showMigration && !showNoTopics && !taskLoadError">
        <div class="tasks-board-surface">
        <div class="management-board">
            <div class="filter-tool-bar">
                <div class="toolbar-group toolbar-primary">
                    <ng-container *ngIf="!isLoading; else searchLoader">
                        <mat-form-field class="search-field">
                            <img src="../../assets/images/search.svg" alt="search" matPrefix />
                            <input matInput placeholder="Search" [(ngModel)]="search" (keyup)="searchChangeHandler()"
                                autocomplete="off">
                            <button class="clear-btn" *ngIf="search" matSuffix (click)="search=''; clearChangeHandler()">
                                <img src="../../../assets/images/cross_icon_grey.svg" height="20px" width="20px" alt="clear">
                            </button>
                        </mat-form-field>
                    </ng-container>
                    <mat-form-field class="board-filter-select" *ngIf="!isLoading">
                        <mat-select [(ngModel)]="filterPriorities" (selectionChange)="advancedFilterChangeHandler()"
                            multiple [panelClass]="['task-filter-select-panel', 'board-filter-select-panel']"
                            placeholder="Priority: All">
                            <mat-select-trigger>
                                {{filterPriorities.length ? priorityFilterLabel() : 'Priority: All'}}
                            </mat-select-trigger>
                            <mat-option value="LOW">Low</mat-option>
                            <mat-option value="MEDIUM">Medium</mat-option>
                            <mat-option value="HIGH">High</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field class="board-filter-select" *ngIf="!isLoading">
                        <mat-select [(ngModel)]="filterStatuses" (selectionChange)="advancedFilterChangeHandler()"
                            multiple [panelClass]="['task-filter-select-panel', 'board-filter-select-panel']"
                            placeholder="Status: All">
                            <mat-select-trigger>
                                {{filterStatuses.length ? statusFilterLabel() : 'Status: All'}}
                            </mat-select-trigger>
                            <mat-option value="TODO">To do</mat-option>
                            <mat-option value="IN_PROGRESS">In progress</mat-option>
                            <mat-option value="BLOCKED">Blocked</mat-option>
                            <mat-option value="IN_REVIEW">In review</mat-option>
                            <mat-option value="DONE">Completed</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="toolbar-group toolbar-actions">
                    <ng-container *ngIf="!isLoading">
                        <button type="button" class="filter-menu-btn" [matMenuTriggerFor]="taskFiltersMenu" aria-label="More filters">
                            <mat-icon>tune</mat-icon>
                            <span class="filter-count" *ngIf="activeAdvancedFilters">
                                {{activeAdvancedFilters}}
                            </span>
                        </button>
                        <mat-menu #taskFiltersMenu="matMenu" class="task-filter-menu" xPosition="before">
                            <div class="task-filter-panel" (click)="$event.stopPropagation()">
                                <div class="filter-panel-header">
                                    <span>Task Filters</span>
                                    <button type="button" class="clear-btn" (click)="clearAdvancedFilters()">
                                        <mat-icon>filter_alt_off</mat-icon>
                                        Clear all
                                    </button>
                                </div>

                                <div class="filter-source-group">
                                    <span class="filter-label">Task source</span>
                                    <div class="filter-checkbox-row">
                                        <mat-checkbox [checked]="isSourceSelected('native')"
                                            (change)="toggleSourceFilter('native')">SPIKE</mat-checkbox>
                                        <mat-checkbox [checked]="isSourceSelected('clickup')"
                                            (change)="toggleSourceFilter('clickup')">ClickUp</mat-checkbox>
                                    </div>
                                </div>

                                <div class="filter-select-group">
                                    <span class="filter-label">Priority</span>
                                    <mat-form-field appearance="fill" class="filter-field filter-select-field">
                                    <mat-select [(ngModel)]="filterPriorities" (selectionChange)="advancedFilterChangeHandler()"
                                        multiple panelClass="task-filter-select-panel" placeholder="All">
                                        <mat-select-trigger>{{priorityFilterLabel()}}</mat-select-trigger>
                                        <mat-option value="LOW">Low</mat-option>
                                        <mat-option value="MEDIUM">Medium</mat-option>
                                        <mat-option value="HIGH">High</mat-option>
                                    </mat-select>
                                    </mat-form-field>
                                </div>

                                <div class="filter-select-group">
                                    <span class="filter-label">Status</span>
                                    <mat-form-field appearance="fill" class="filter-field filter-select-field">
                                    <mat-select [(ngModel)]="filterStatuses" (selectionChange)="advancedFilterChangeHandler()"
                                        multiple panelClass="task-filter-select-panel" placeholder="All">
                                        <mat-select-trigger>{{statusFilterLabel()}}</mat-select-trigger>
                                        <mat-option value="TODO">To do</mat-option>
                                        <mat-option value="IN_PROGRESS">In progress</mat-option>
                                        <mat-option value="BLOCKED">Blocked</mat-option>
                                        <mat-option value="IN_REVIEW">In review</mat-option>
                                        <mat-option value="DONE">Completed</mat-option>
                                    </mat-select>
                                    </mat-form-field>
                                </div>

                                <div class="filter-select-group">
                                    <span class="filter-label">Assignee</span>
                                    <mat-form-field appearance="fill" class="filter-field filter-select-field">
                                    <mat-select [ngModel]="filterAssigneeIds" (ngModelChange)="setFilterAssigneeIds($event)"
                                        multiple panelClass="task-filter-select-panel assignee-filter-select-panel"
                                        placeholder="Select people">
                                        <mat-select-trigger>{{assigneeFilterLabel()}}</mat-select-trigger>
                                        <mat-option *ngFor="let person of assigneeList; trackBy: trackByMemberId"
                                            [value]="person.id">
                                            <span class="filter-assignee-option">
                                                <img *ngIf="person.avatarUrl" [appAvatarImage]="person.avatarUrl" [src]="person.avatarUrl" [alt]="person | memberFullName" />
                                                <span *ngIf="!person.avatarUrl" class="filter-assignee-avatar"
                                                    [style.background]="avatarColorFor(person.id)">
                                                    {{person | memberInitials}}
                                                </span>
                                                {{person | memberFullName}}
                                            </span>
                                        </mat-option>
                                    </mat-select>
                                    </mat-form-field>
                                </div>

                                <div class="filter-select-group">
                                    <span class="filter-label">Period</span>
                                    <mat-form-field appearance="fill" class="filter-field filter-select-field">
                                    <mat-select #periodSelect [ngModel]="filterPeriod" (ngModelChange)="setPeriodFilter($event)"
                                        panelClass="task-filter-select-panel period-filter-select-panel">
                                        <mat-select-trigger>
                                            {{periodFilterLabel()}}
                                        </mat-select-trigger>
                                        <mat-option value="today">Today</mat-option>
                                        <mat-option value="this_week">This Week</mat-option>
                                        <mat-option value="all_time">All Time</mat-option>
                                        <mat-option value="custom" (click)="openCustomPeriodPicker()">
                                            <span class="period-custom-option">
                                                <mat-icon>schedule</mat-icon>
                                                Select Period
                                            </span>
                                        </mat-option>
                                    </mat-select>
                                    </mat-form-field>

                                    <mat-form-field class="period-picker-shell">
                                        <mat-date-range-input [rangePicker]="periodPicker">
                                            <input matStartDate [ngModel]="filterDueFromDate"
                                                (dateChange)="setCustomPeriodDate('start', $event.value)">
                                            <input matEndDate [ngModel]="filterDueToDate"
                                                (dateChange)="setCustomPeriodDate('end', $event.value)">
                                        </mat-date-range-input>
                                        <mat-date-range-picker #periodPicker
                                            panelClass="task-period-calendar-panel"
                                            (closed)="applyCustomPeriodFilter()"></mat-date-range-picker>
                                    </mat-form-field>
                                </div>
                            </div>
                        </mat-menu>
                    </ng-container>
                    <ng-container *ngIf="!isLoading; else suggestTaskLoader">
                        <button *ngIf="suggestTaskAvailable" (click)="openSuggestTask()" class="create-new-btn" mat-flat-button>
                            <mat-icon class="icon">add</mat-icon>
                            {{"Create task"}}
                        </button>
                    </ng-container>
                </div>
            </div>
        </div>
        <div class="tasks-section" *ngIf="taskView === 'board'" [class.tasks-section-refreshing]="isRefreshingTasks" cdkDropListGroup>
            <ng-container *ngIf="!isLoading; else laneLoader">
                <div class="lane" *ngFor="let taskData of taskDatas; trackBy: trackByLaneStatus"
                    [ngClass]="'lane-' + taskData.ui.slug">
                    <div class="lane-header">
                        <div class="lane-title">
                            <span class="lane-dot" [style.background]="taskData.ui.color"></span>
                            {{taskData.ui.label}}
                        </div>
                        <span class="count">{{taskData.tasks.length}}</span>
                    </div>
                    <div class="lane-body"
                        cdkDropList
                        [cdkDropListData]="taskData.tasks"
                        (cdkDropListDropped)="dropTask($event, taskData)">
                        <ng-container *ngFor="let cardData of taskData.tasks; trackBy: trackByTaskId">
                            <app-task-card [cardData]="cardData"
                                cdkDrag
                                [cdkDragData]="cardData"
                                (cdkDragStarted)="taskDragStarted(taskData.status)"
                                (cdkDragEnded)="taskDragEnded()"
                                (cardClickEvent)="getTaskDetails($event, taskData.status)"
                                (assigneeClickEvent)="openAssignee($event)"></app-task-card>
                        </ng-container>
                        <div class="task-drop-slot" *ngIf="shouldShowDropSlot(taskData)" aria-hidden="true"></div>
                        <button type="button" class="add-task-inline" *ngIf="suggestTaskAvailable"
                            (click)="openSuggestTask()">
                            <mat-icon>add</mat-icon>
                            Add task
                        </button>
                    </div>
                </div>
            </ng-container>
        </div>
        <div class="tasks-list-view" *ngIf="taskView === 'list'" [class.tasks-list-refreshing]="isRefreshingTasks">
            <ng-container *ngIf="!isLoading; else laneLoader">
                <app-portal-table
                    [columns]="taskListColumns"
                    [rows]="visibleListTasks()"
                    trackByKey="taskId"
                    [loading]="false"
                    [sortActive]="listSortKey"
                    [sortDirection]="listPortalSortDirection"
                    emptyTitle="No tasks found"
                    emptyDescription="Try adjusting your filters or create a new task."
                    (sortChange)="portalListSortChange($event)"
                    (rowClick)="openTaskListRow($event)">
                    <ng-template portalTableCell="task" let-cardData>
                        <span class="list-task-main" [class.completed-row]="cardData.ui.isCompleted">
                            <span class="list-title-line">
                                <span class="list-title">{{cardData.title}}</span>
                                <img class="list-clickup-mark" *ngIf="cardData.source === 'clickup'"
                                    src="assets/images/clickuplogo.png" alt="ClickUp task" />
                            </span>
                            <span class="list-description" *ngIf="cardData.description">{{cardData.description}}</span>
                        </span>
                    </ng-template>

                    <ng-template portalTableCell="status" let-cardData>
                        <app-portal-status-pill
                            [status]="cardData.ui.status"
                            [label]="cardData.ui.statusLabel"
                            [showDot]="true">
                        </app-portal-status-pill>
                    </ng-template>

                    <ng-template portalTableCell="priority" let-cardData>
                        <app-portal-status-pill
                            [status]="cardData.priority"
                            [label]="cardData.ui.priorityLabel"
                            [tone]="taskPriorityTone(cardData)"
                            [showDot]="true">
                        </app-portal-status-pill>
                    </ng-template>

                    <ng-template portalTableCell="dueDate" let-cardData>
                        <span class="list-due" [class.urgent]="cardData.ui.isDueSoon">
                            <mat-icon>event</mat-icon>
                            {{listDueLabel(cardData)}}
                        </span>
                    </ng-template>

                    <ng-template portalTableCell="assignees" let-cardData>
                        <span class="list-assignees">
                            <span class="list-avatar-stack" *ngIf="cardData.ui.assignees.length; else noAssignees">
                                <span class="list-avatar" *ngFor="let assignee of cardData.ui.visibleAssignees; trackBy: trackByMemberId"
                                    [matTooltip]="cardData.ui.assigneeTooltip" matTooltipPosition="above">
                                    <img *ngIf="assignee.avatarUrl" [appAvatarImage]="assignee.avatarUrl" [src]="assignee.avatarUrl" [alt]="cardData.ui.assigneeTooltip" />
                                    <span *ngIf="!assignee.avatarUrl" [style.background]="avatarColorFor(assignee.id)">
                                        {{assignee | memberInitials}}
                                    </span>
                                </span>
                                <span class="list-avatar list-avatar-more" *ngIf="cardData.ui.extraAssigneeCount">
                                    +{{cardData.ui.extraAssigneeCount}}
                                </span>
                            </span>
                            <ng-template #noAssignees>
                                <span class="list-muted">Unassigned</span>
                            </ng-template>
                        </span>
                    </ng-template>

                    <ng-template portalTableCell="assets" let-cardData>
                        <span class="list-assets-cell">
                            <span class="asset-count">
                                <mat-icon>attach_file</mat-icon>
                                {{cardData.documentsCount || 0}}
                            </span>
                            <span class="asset-count">
                                <mat-icon>chat_bubble_outline</mat-icon>
                                {{cardData.commentsCount || 0}}
                            </span>
                        </span>
                    </ng-template>

                    <app-portal-table-footer
                        portalTableFooter
                        [total]="listTasks().length"
                        [pageIndex]="listCurrentPageValue() - 1"
                        [pageSize]="listRowsPerPage"
                        [visibleCount]="visibleListTasks().length"
                        [pageSizeOptions]="listRowsPerPageOptions"
                        (pageIndexChange)="setListPageIndex($event)"
                        (pageSizeChange)="setListRowsPerPage($event)">
                    </app-portal-table-footer>
                </app-portal-table>
            </ng-container>
        </div>
        <div class="tasks-calendar-view" *ngIf="taskView === 'calendar'" [class.tasks-calendar-refreshing]="isRefreshingTasks">
            <ng-container *ngIf="!isLoading; else laneLoader">
                <div class="calendar-card">
                    <div class="calendar-main">
                        <div class="calendar-toolbar">
                            <div>
                                <span class="calendar-eyebrow">Calendar</span>
                                <h2>{{calendarMonthLabel()}}</h2>
                            </div>
                            <div class="calendar-toolbar-actions">
                                <div class="calendar-mode-switch" aria-label="Calendar mode">
                                    <button type="button" [class.active]="calendarMode === 'month'" (click)="setCalendarMode('month')">
                                        Month
                                    </button>
                                    <button type="button" [class.active]="calendarMode === 'week'" (click)="setCalendarMode('week')">
                                        Week
                                    </button>
                                </div>
                                <button type="button" class="calendar-today-btn" (click)="goToCurrentCalendarMonth()">Today</button>
                                <button type="button" class="calendar-nav-btn" (click)="previousCalendarMonth()">
                                    <mat-icon>chevron_left</mat-icon>
                                </button>
                                <button type="button" class="calendar-nav-btn" (click)="nextCalendarMonth()">
                                    <mat-icon>chevron_right</mat-icon>
                                </button>
                            </div>
                        </div>
                        <div class="calendar-weekdays">
                            <span *ngFor="let weekday of calendarWeekdays">{{weekday}}</span>
                        </div>
                        <div class="calendar-grid" [class.week-mode]="calendarMode === 'week'">
                            <div class="calendar-week" *ngFor="let week of calendarRows(); trackBy: trackByCalendarWeek">
                                <div class="calendar-day"
                                    *ngFor="let day of week; trackBy: trackByCalendarDay"
                                    [class.muted]="!day.isCurrentMonth"
                                    [class.today]="day.isToday"
                                    [class.selected]="day.isSelected"
                                    [class.has-tasks]="day.tasks.length"
                                    (click)="selectCalendarDay(day)">
                                    <div class="calendar-day-top">
                                        <span class="calendar-day-number">{{day.dayNumber}}</span>
                                        <span class="calendar-day-meta" *ngIf="day.tasks.length">
                                            <span class="calendar-day-count" [class.overflow]="calendarOverflowCount(day)">
                                                {{day.tasks.length}}
                                            </span>
                                            <span class="calendar-day-more" *ngIf="calendarOverflowCount(day)">
                                                +{{calendarOverflowCount(day)}} more
                                            </span>
                                        </span>
                                    </div>
                                    <div class="calendar-day-tasks">
                                        <div class="calendar-task-stack" *ngIf="day.tasks.length">
                                            <button type="button" class="calendar-task"
                                                *ngFor="let cardData of calendarVisibleTasks(day); trackBy: trackByTaskId"
                                                [ngClass]="cardData.ui.priorityClass"
                                                (click)="openCalendarTask($event, cardData)">
                                                <span class="calendar-task-dot" [style.background]="cardData.ui.statusColor"></span>
                                                <span class="calendar-task-title">{{cardData.title}}</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <aside class="calendar-side">
                        <div class="calendar-side-card">
                            <span class="side-label">This month</span>
                            <strong>{{calendarMonthTaskCount()}}</strong>
                            <span>scheduled task{{calendarMonthTaskCount() === 1 ? '' : 's'}}</span>
                        </div>
                        <div class="calendar-side-card selected-day-card">
                            <span class="side-label">Selected day</span>
                            <div class="side-heading">
                                <span>{{selectedCalendarDateLabel()}}</span>
                                <span>{{selectedCalendarTasks().length}}</span>
                            </div>
                            <button type="button" class="selected-day-task"
                                *ngFor="let cardData of selectedCalendarTasks(); trackBy: trackByTaskId"
                                (click)="getTaskDetails(cardData, cardData.ui.status)">
                                <span class="calendar-task-dot" [style.background]="cardData.ui.statusColor"></span>
                                <span class="selected-day-task-main">
                                    <span>{{cardData.title}}</span>
                                    <small>{{cardData.ui.statusLabel}} · {{cardData.ui.priorityLabel}}</small>
                                </span>
                            </button>
                            <span class="calendar-empty-copy" *ngIf="!selectedCalendarTasks().length">
                                No tasks scheduled for this day.
                            </span>
                        </div>
                        <div class="calendar-side-card no-due-card">
                            <div class="side-heading">
                                <span>No due date</span>
                                <span>{{calendarNoDueTasks().length}}</span>
                            </div>
                            <button type="button" class="no-due-task"
                                *ngFor="let cardData of calendarNoDueTasks(); trackBy: trackByTaskId"
                                (click)="getTaskDetails(cardData, cardData.ui.status)">
                                <span class="calendar-task-dot" [style.background]="cardData.ui.statusColor"></span>
                                <span>{{cardData.title}}</span>
                            </button>
                            <span class="calendar-empty-copy" *ngIf="!calendarNoDueTasks().length">
                                Everything has a date. Tiny miracle.
                            </span>
                        </div>
                    </aside>
                </div>
            </ng-container>
        </div>
        </div>
    </ng-container>
</div>

<ng-template #searchLoader>
    <ngx-skeleton-loader count="1" appearance="line" [theme]="{
            width: '400px',
            height: '38px',
            marginBottom: 0
          }"></ngx-skeleton-loader>
</ng-template>
<ng-template #suggestTaskLoader>
    <div style="margin-left: auto;">
        <ngx-skeleton-loader count="1" appearance="line" [theme]="{
            width: '160px',
            height: '38px',
            marginBottom: 0,
            marginLeft: 'auto'
          }"></ngx-skeleton-loader>
    </div>
</ng-template>

<ng-template #taskCardLoader>
    <div class="lane-body">
        <div *ngFor="let number of [0, 1]; trackBy: trackByNumber">
            <ngx-skeleton-loader count="1" appearance="line" [theme]="{
                width: '258px',
                height: '120px',
                marginBottom: 0
                        }"></ngx-skeleton-loader>
        </div>
    </div>
</ng-template>

<ng-template #laneLoader>
    <div class="lane" *ngFor="let number of [0, 1, 2, 3]; trackBy: trackByNumber">
        <div class="lane-header">
            <ngx-skeleton-loader count="1" appearance="line" [theme]="{
                width: '150px',
                height: '25px',
                display: 'block',
                marginBottom: 0
              }"></ngx-skeleton-loader>
        </div>
        <ng-container *ngIf="!isLoading; else taskCardLoader">
            <div class="lane-body">
                <div *ngFor="let number of [0, 1]; trackBy: trackByNumber">
                    <ngx-skeleton-loader count="1" appearance="line" [theme]="{
                        width: '258px',
                        height: '120px',
                        marginBottom: 0
                                }"></ngx-skeleton-loader>
                </div>
            </div>
        </ng-container>
    </div>
</ng-template>
